import { render } from "./WaitBlockComponent.vue?vue&type=template&id=6c3778a1&scoped=true"
import script from "./WaitBlockComponent.vue?vue&type=script&lang=js"
export * from "./WaitBlockComponent.vue?vue&type=script&lang=js"

import "./WaitBlockComponent.vue?vue&type=style&index=0&id=6c3778a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c3778a1"

export default script